var _ellipse, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustKlaimGagal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 169,
    viewBox: "0 0 203 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.064,
    cy: 84.2144,
    rx: 84.1275,
    ry: 84.1274,
    fill: "url(#paint0_linear_961_134)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.34198,
    cy: 4.34198,
    r: 4.34198,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 41.1719 41.7612)",
    fill: "#FFC70F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.34198,
    cy: 4.34198,
    r: 4.34198,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 194.248 74.6357)",
    fill: "#FFC70F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 1.12402 102.318)",
    fill: "#FFC70F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 149.625 145.724)",
    fill: "#FFC70F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.17099,
    cy: 2.17099,
    r: 2.17099,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 166.994 9.28833)",
    fill: "#FFC70F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.804 124.804C169.78 101.828 169.78 64.5773 146.804 41.6015C123.828 18.6257 86.5772 18.6257 63.6014 41.6015C40.6256 64.5773 40.6256 101.828 63.6014 124.804C86.5772 147.78 123.828 147.78 146.804 124.804Z",
    fill: "url(#paint1_linear_961_134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.202 143.265C72.083 143.265 45.1299 116.324 45.1299 83.1933C45.1299 50.0745 72.083 23.1338 105.202 23.1338C138.321 23.1338 165.274 50.0745 165.274 83.2057C165.274 116.324 138.321 143.265 105.202 143.265ZM105.202 25.61C73.4449 25.61 47.6061 51.4488 47.6061 83.2057C47.6061 114.963 73.4449 140.801 105.202 140.801C136.959 140.801 162.798 114.963 162.798 83.2057C162.798 51.4488 136.959 25.61 105.202 25.61Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1592 148.998C71.1413 148.998 46.5653 129.139 40.7215 101.777C40.6101 101.269 40.932 100.787 41.4396 100.675C41.9473 100.564 42.4301 100.886 42.5415 101.393C48.1996 127.901 72.0203 147.141 99.1592 147.141C105.288 147.141 111.33 146.187 117.099 144.305C117.582 144.144 118.114 144.417 118.275 144.9C118.436 145.382 118.164 145.915 117.681 146.076C111.726 148.007 105.486 148.998 99.1592 148.998ZM138.555 133.856C138.295 133.856 138.047 133.757 137.862 133.546C137.515 133.163 137.552 132.581 137.924 132.234C150.082 121.265 157.052 105.59 157.052 89.2229V88.9753C157.052 88.4677 157.473 88.0467 157.981 88.0467C158.488 88.0467 158.909 88.4677 158.909 88.9753V89.2229C158.909 106.11 151.716 122.292 139.162 133.608C139.001 133.782 138.778 133.856 138.555 133.856ZM40.3377 90.2258C39.8301 90.2258 39.4092 89.8667 39.4092 89.3591V89.2353C39.4092 72.3973 46.5777 56.2403 59.07 44.9366C59.4538 44.5899 60.0357 44.6271 60.3823 44.9985C60.729 45.3823 60.6919 45.9642 60.3204 46.3109C48.212 57.2803 41.2787 72.9173 41.2787 89.2353C41.2663 89.7429 40.8454 90.2258 40.3377 90.2258ZM156.668 77.6963C156.235 77.6963 155.851 77.3992 155.764 76.9659C150.057 50.5204 126.261 31.33 99.1592 31.33C92.9935 31.33 86.9145 32.2957 81.1079 34.2024C80.6127 34.3633 80.0927 34.091 79.9317 33.6081C79.7708 33.1253 80.0431 32.5929 80.526 32.4319C86.5183 30.4634 92.7954 29.4729 99.1592 29.4729C127.115 29.4729 151.691 49.2823 157.572 76.5697C157.683 77.0649 157.362 77.5601 156.854 77.6716C156.804 77.6963 156.743 77.6963 156.668 77.6963Z",
    fill: "#680C20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.393 66.3182L124.38 57.3049L104.781 76.9038L85.1822 57.3049L76.1689 66.3182L95.7678 85.9171L76.1689 105.516L85.1822 114.542L104.781 94.9427L124.38 114.542L133.393 105.516L113.794 85.9171L133.393 66.3182Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.379 116.671L104.78 97.0723L85.1815 116.671L74.0264 105.516L93.6253 85.9171L74.0264 66.3182L85.1815 55.1631L104.78 74.762L124.379 55.1631L135.534 66.3182L115.936 85.9171L135.534 105.516L124.379 116.671ZM104.78 92.8009L124.379 112.4L131.263 105.516L111.664 85.9171L131.263 66.3182L124.379 59.4345L104.78 79.0458L85.1815 59.4469L78.2978 66.3306L97.8967 85.9295L78.2978 105.516L85.1815 112.4L104.78 92.8009Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_961_134",
    x1: 17.9365,
    y1: -16.2712,
    x2: 142.726,
    y2: 152.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749499,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_961_134",
    x1: 28.8281,
    y1: 81.4391,
    x2: 175.486,
    y2: 115.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.619792,
    stopColor: "#E90111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976066,
    stopColor: "#A8010D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustKlaimGagal);
export default __webpack_public_path__ + "static/media/illust-klaim-gagal.8987d3850d9c47281d3fff444220ae1a.svg";
export { ForwardRef as ReactComponent };